export const APP_NAME = 'collections_perseus';
